import instance from "../api/instance";
import { logout } from "./sessionActions";
import { queryString, getFilters } from "../../components/utils/functions";

import {
  GET_PROVIDERS,
  SET_ACH_ACCOUNTS,
  PENDING_PROVIDERS,
  GET_PROVIDER_BY_ID,
  CLEAR_PROVIDER_LIST,
  GET_PROVIDERS_MODULES,
  CLEAR_PENDING_PROVIDERS,
} from "../constants/constants";

export const getProvidersList = (page = 0, size = 10, filters = []) => {
  filters.push({
    property: "status",
    operator: "in",
    value: "TRANSITORY,ACTIVE,INACTIVE,REJECTED",
  });
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];

  var query = searchFilters !== "" ? `&${queryString(queryFilters)}` : "";
  var url = `/companies/me/providers?page=${page}&size=${size}${query}&sort=updateDate,DESC`;

  return (dispatch) => {
    return instance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getAllProviders = (page = 0, size = 10, filters = []) => {
  const search = [
    { property: "status", operator: "not", value: "DELETED" },
    ...filters,
  ]
    .map(({ property, operator, value }) => `${property}/${operator}/${value}`)
    .join("|");

  return async (dispatch) => {
    try {
      const response = await instance.get("/providers", {
        params: {
          page,
          size,
          sort: "updateDate,DESC",
          search,
        },
      });
      dispatch({
        type: GET_PROVIDERS,
        providers: response.data.data,
      });
    } catch (err) {
      const statusCode = err.response.status;

      switch (statusCode) {
        case 401: // Deslogueamos porque el token es inválido
          dispatch(logout());
          break;
        default:
          return Promise.reject(err);
      }
    }
  };
};

export const getProvidersByClient = (id, page = 0, size = 10, filters = []) => {
  filters.push({ property: "status", operator: "not", value: "DELETED" });
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];

  var query = searchFilters !== "" ? `&${queryString(queryFilters)}` : "";
  var url = `/companies/${id}/providers?page=${page}&size=${size}${query}&sort=updateDate,DESC`;

  return (dispatch) => {
    return instance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getProviderById = (providerId, companyId) => {
  return (dispatch) => {
    return instance
      .get(`/providers/${companyId}/${providerId}`)
      .then((response) => {
        dispatch({
          type: GET_PROVIDER_BY_ID,
          provider: response.data.data,
        });
        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

//url admissions
export const getProviderAdmissions =
  (providerId, companyId, currency) => async (dispatch) => {
    try {
      const response = await instance.get(
        `/providers/${companyId}/${providerId}/${currency}`
      );
      dispatch({
        type: GET_PROVIDER_BY_ID,
        provider: response.data.data,
      });
      return response.data;
    } catch (err) {
      const statusCode = err.response.status;
      if (statusCode === 401) dispatch(logout());
      else return Promise.reject(err);
    }
  };

export const getProviderCSAById = (id) => {
  return (dispatch) => {
    return instance
      .get(`/providers/company/${id}`)
      .then((response) => {
        dispatch({
          type: GET_PROVIDER_BY_ID,
          provider: response.data.data,
        });
        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getSearchContent = (filters) => {
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];

  return (dispatch) => {
    return instance
      .get(`/companies/me/providers?${queryString(queryFilters)}`)
      .then((response) => {
        dispatch({
          type: GET_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

//FILTER METHOD FOR PROVIDERS IN BSC
export const getSearchContentBSC = (filters) => {
  const queryFilters = [{ property: "search", value: getFilters(filters) }];
  return (dispatch) => {
    return instance
      .get(`/providers?${queryString(queryFilters)}`)
      .then((response) => {
        dispatch({
          type: GET_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getSearchContentProvidersClient = (id, filters) => {
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];

  return (dispatch) => {
    return instance
      .get(`/companies/${id}/providers?${queryString(queryFilters)}`)
      .then((response) => {
        dispatch({
          type: GET_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getPendingProviders = (
  page = 0,
  size = 10,
  filters = [],
  signal
) => {
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];

  return (dispatch) => {
    return instance
      .get(
        `/companies/me/providers?page=${page}&size=${size}&${queryString(
          queryFilters
        )}&sort=updateDate,DESC`,
        { signal }
      )
      .then((response) => {
        dispatch({
          type: PENDING_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getInvitationProviders = (
  page = 0,
  size = 10,
  filters = [],
  signal
) => {
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];
  let query = searchFilters === "" ? "" : `&${queryString(queryFilters)}`;

  return (dispatch) => {
    return instance
      .get(
        `/providers/provider-invitation?page=${page}&size=${size}${query}&sort=updateDate,DESC`,
        { signal }
      )
      .then((response) => {
        dispatch({
          type: PENDING_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getProvidersAdditionsAccounts = (
  page = 0,
  size = 10,
  filters = [],
  signal
) => {
  var searchFilters = getFilters(filters);
  var queryFilters = [{ property: "search", value: searchFilters }];
  let query = searchFilters === "" ? "" : `&${queryString(queryFilters)}`;

  return (dispatch) => {
    return instance
      .get(
        `/providers/additions-modifications-accounts?page=${page}&size=${size}${query}&sort=updateDate,DESC`,
        { signal }
      )
      .then((response) => {
        console.log("RES", response);
        dispatch({
          type: PENDING_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        console.log("ERR", err);
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getPendingProvidersBSC = (page = 0, size = 10, filters = []) => {
  // filters.unshift({ property: 'pendingChange', operator: 'eq', value: 'true' });
  filters.unshift({ property: "pendingChange", operator: "eq", value: "true" });

  var searchFilters = getFilters(filters);

  var queryFilters = [{ property: "sort", value: "updateDate,DESC" }];
  queryFilters.push({ property: "search", value: searchFilters });

  return (dispatch) => {
    return instance
      .get(`/providers?page=${page}&size=${size}&${queryString(queryFilters)}`)
      .then((response) => {
        dispatch({
          type: PENDING_PROVIDERS,
          providers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getACHBanks = (country) => {
  return (dispatch) => {
    return instance
      .get(`/banks/bank-ach/${country}`)
      .then((response) => {
        dispatch({
          type: SET_ACH_ACCOUNTS,
          banks: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getProviderModules = (institutionId) => {
  return (dispatch) => {
    return instance
      .get(`/providers/modules/${institutionId}`)
      .then((response) => {
        dispatch({
          type: GET_PROVIDERS_MODULES,
          modules: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const clearProvidersList = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_PROVIDER_LIST,
    });
};

export const clearPendingProviders = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_PENDING_PROVIDERS,
    });
};
